import styled from "styled-components";

const Logo = styled.img`
	max-width: 30%;
	float: ${({float}) => float && float};
	margin: 2rem;
`;

export default Logo;